import Http from './http';
import store from 'store';

class ThemesService {
    constructor() {
        this.themes = null;
        this.flatThemes = null;
        store.set('themes', false);
        store.set('flatThemes', false);
    }

    resetCache(){
        store.set('themes', false);
        store.set('flatThemes', false);
        this.themes = null;
        this.flatThemes = null;
        this.getThemes();
    }

    recurseThemes(current, root='') {
        let return_object = {}
        current.children.map(theme => {
            return_object[theme.id] = root + theme.name
            return_object = {...return_object, ...this.recurseThemes(theme, root + theme.name + ' - ')}
        })
        return return_object
    }

    getThemes() {
        return new Promise((resolve, reject) => {
            if (store.get('themes', false)){
                this.themes = store.get('themes');
            }
            if (this.themes) resolve({themes: this.themes, flatThemes: this.flatThemes});
            else {
                Http.get('/themes/?full=true').then(resp => {
                    this.themes = {'children': resp.data.themes, 'name': 'Themes', 'id':'Themes', 'original_name': 'Themes', 'riskfusionref': 'Themes'};
                    store.set('themes', this.themes);
                    this.flatThemes = this.recurseThemes(this.themes)
                    store.set('flatThemes', this.flatThemes);
                    resolve({themes: this.themes, flatThemes: this.flatThemes});
                });
            }
        })
    }
}

export default new ThemesService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/themes.js